import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App'; // Your main App component
import { MemberProvider } from './Hooks/MemberContext';
import { ErrorBoundary } from './Components/Custom/ErrorBoundary';
import './index.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter';

// Find the root element in your HTML
const container = document.getElementById('root');

// Ensure container is not null
if (container) {
  // Create a root for your application
  const root = createRoot(container);

  // Render your app component within the BrowserRouter
  root.render(
    <React.StrictMode>
      {/* A render crash shows ErrorPage, not a blank screen (#652). */}
      <ErrorBoundary>
        <BrowserRouter>
          {/* MemberProvider loads `GET /member-portal/me` once and is what
              every screen reads the member's name, email and homes from.
              It was written but never mounted, which is why the sidebar
              was permanently blank. */}
          <MemberProvider>
            <App />
          </MemberProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  console.error('Failed to find the root element');
}
